export const GET_CURRENT_USER = "GET_CURRENT_USER";
